import React from 'react';
import { Link } from 'react-router-dom';
import { Cpu, Twitter, Github, Linkedin, ArrowRight } from 'lucide-react';
export const Footer = () => {
  return <footer className="bg-lab-dark border-t border-white/[0.05] pt-20 pb-10" data-id="element-22">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-23">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-24">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2 lg:col-span-1" data-id="element-25">
            <Link to="/" className="flex items-center gap-2 mb-6" data-id="element-26">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-lab-violet to-lab-blue flex items-center justify-center" data-id="element-27">
                <Cpu size={18} className="text-white" data-id="element-28" />
              </div>
              <span className="font-display font-bold text-lg tracking-widest text-white" data-id="element-29">
                CLVN<span className="text-lab-muted font-light" data-id="element-30">–</span>LRR
              </span>
            </Link>
            <p className="text-lab-muted text-sm leading-relaxed mb-6" data-id="element-31">
              Laboratorio de optimización cognitiva y sistemas avanzados.
              Diseñando el futuro de la productividad humana a través de
              inteligencia aplicada.
            </p>
            <div className="flex items-center gap-4" data-id="element-32">
              <a href="#" className="text-lab-muted hover:text-white transition-colors" data-id="element-33">
                <Twitter size={20} data-id="element-34" />
              </a>
              <a href="#" className="text-lab-muted hover:text-white transition-colors" data-id="element-35">
                <Github size={20} data-id="element-36" />
              </a>
              <a href="#" className="text-lab-muted hover:text-white transition-colors" data-id="element-37">
                <Linkedin size={20} data-id="element-38" />
              </a>
            </div>
          </div>

          {/* Links */}
          <div data-id="element-39">
            <h4 className="font-display font-medium text-white mb-6" data-id="element-40">
              Laboratorio
            </h4>
            <ul className="space-y-4" data-id="element-41">
              <li data-id="element-42">
                <Link to="/catalog" className="text-lab-muted hover:text-white text-sm transition-colors" data-id="element-43">
                  Sistemas Digitales
                </Link>
              </li>
              <li data-id="element-44">
                <Link to="/catalog" className="text-lab-muted hover:text-white text-sm transition-colors" data-id="element-45">
                  Prompts Avanzados
                </Link>
              </li>
              <li data-id="element-46">
                <Link to="/catalog" className="text-lab-muted hover:text-white text-sm transition-colors" data-id="element-47">
                  Neuro-Optimización
                </Link>
              </li>
              <li data-id="element-48">
                <Link to="/about" className="text-lab-muted hover:text-white text-sm transition-colors" data-id="element-49">
                  Nuestra Tesis
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-50">
            <h4 className="font-display font-medium text-white mb-6" data-id="element-51">
              Soporte
            </h4>
            <ul className="space-y-4" data-id="element-52">
              <li data-id="element-53">
                <Link to="/contact" className="text-lab-muted hover:text-white text-sm transition-colors" data-id="element-54">
                  Contacto
                </Link>
              </li>
              <li data-id="element-55">
                <a href="#" className="text-lab-muted hover:text-white text-sm transition-colors" data-id="element-56">
                  Documentación
                </a>
              </li>
              <li data-id="element-57">
                <a href="#" className="text-lab-muted hover:text-white text-sm transition-colors" data-id="element-58">
                  Términos de Servicio
                </a>
              </li>
              <li data-id="element-59">
                <a href="#" className="text-lab-muted hover:text-white text-sm transition-colors" data-id="element-60">
                  Privacidad
                </a>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div data-id="element-61">
            <h4 className="font-display font-medium text-white mb-6" data-id="element-62">
              Protocolo de Acceso
            </h4>
            <p className="text-lab-muted text-sm mb-4" data-id="element-63">
              Únete al 1% que optimiza su mente. Recibe actualizaciones de
              sistemas.
            </p>
            <div className="flex items-center glass-panel rounded-full p-1 border border-white/10 focus-within:border-lab-violetLight/50 transition-colors" data-id="element-64">
              <input type="email" placeholder="tu@email.com" className="bg-transparent border-none outline-none text-sm text-white px-4 w-full placeholder:text-lab-muted/50" data-id="element-65" />
              <button className="bg-white text-lab-black w-8 h-8 rounded-full flex items-center justify-center hover:bg-gray-200 transition-colors shrink-0" data-id="element-66">
                <ArrowRight size={16} data-id="element-67" />
              </button>
            </div>
          </div>
        </div>

        <div className="border-t border-white/[0.05] pt-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-68">
          <p className="text-lab-muted text-xs" data-id="element-69">
            © {new Date().getFullYear()} CLVN–LRR Digital Labs. Todos los
            derechos reservados.
          </p>
          <div className="flex items-center gap-2" data-id="element-70">
            <span className="w-2 h-2 rounded-full bg-green-500 shadow-[0_0_10px_rgba(34,197,94,0.5)]" data-id="element-71"></span>
            <span className="text-lab-muted text-xs font-mono" data-id="element-72">
              Sistemas Operativos
            </span>
          </div>
        </div>
      </div>
    </footer>;
};